module.exports = __webpack_public_path__ + "static/media/Validation2.518075e5.png";